export function getFullName(user) {
  if (!user) return "null";
  return user.firstName ? `${user.firstName} ${user.lastName}` : user.lastName;
}
